'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo, useRef, useState } from 'react';
import type { Product } from '@/payload-types';
import { getId } from '@/payload/utilities/payloadObjectHelper';
import { cn } from '@/utilities/ui';
import { useQuery } from '@tanstack/react-query';
import { X } from 'lucide-react';
import type { PaginatedDocs } from 'payload';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
type ProductSearchProps = {
  selected: Product[];
  onChange: (next: Product[]) => void;
  searchCollection: (params: {
    search: string;
    page: number;
    limit: number;
    searchField: string;
    ignoreIds?: number[];
  }) => Promise<PaginatedDocs<Product>>;
  placeholder?: string;
  className?: string;
};
export function ProductSearch(t0) {
  const $ = _c(53);
  const {
    selected,
    onChange,
    searchCollection,
    placeholder: t1,
    className
  } = t0;
  const placeholder = t1 === undefined ? "Search products" : t1;
  const [search, setSearch] = useState("");
  const inputRef = useRef(null);
  let t2;
  if ($[0] !== search) {
    t2 = search.trim();
    $[0] = search;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const trimmedSearch = t2;
  let t3;
  if ($[2] !== selected) {
    t3 = selected.map(_temp);
    $[2] = selected;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const ignoreIds = t3;
  let t4;
  if ($[4] !== ignoreIds || $[5] !== trimmedSearch) {
    t4 = ["productSearch", trimmedSearch, ignoreIds];
    $[4] = ignoreIds;
    $[5] = trimmedSearch;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== ignoreIds || $[8] !== searchCollection || $[9] !== trimmedSearch) {
    t5 = () => searchCollection({
      search: trimmedSearch,
      page: 1,
      limit: 10,
      searchField: "name",
      ignoreIds
    });
    $[7] = ignoreIds;
    $[8] = searchCollection;
    $[9] = trimmedSearch;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = trimmedSearch.length > 0;
  let t7;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t7 = {
      queryKey: t4,
      queryFn: t5,
      enabled: t6
    };
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const {
    data,
    isLoading
  } = useQuery(t7);
  let t8;
  if ($[15] !== data?.docs) {
    t8 = data?.docs ?? [];
    $[15] = data?.docs;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const suggestions = t8;
  let addProduct;
  let t10;
  let t11;
  let t12;
  let t13;
  let t9;
  if ($[17] !== className || $[18] !== onChange || $[19] !== selected) {
    const focusInput = () => {
      inputRef.current?.focus();
    };
    addProduct = product_0 => {
      const productId = getId(product_0);
      if (selected.some(item => getId(item) === productId)) {
        setSearch("");
        focusInput();
        return;
      }
      onChange([...selected, product_0]);
      setSearch("");
      focusInput();
    };
    const removeProduct = product_1 => {
      const productId_0 = getId(product_1);
      onChange(selected.filter(item_0 => getId(item_0) !== productId_0));
      focusInput();
    };
    if ($[26] !== className) {
      t13 = cn("flex flex-col gap-2", className);
      $[26] = className;
      $[27] = t13;
    } else {
      t13 = $[27];
    }
    t12 = "relative";
    t9 = "bg-input border-ring/50 text-foreground focus-within:border-ring focus-within:ring-ring/50 flex min-h-9 flex-wrap items-center gap-1 rounded-md border px-3 py-1 text-base shadow-xs transition-[color,box-shadow] focus-within:ring-[3px] md:text-sm";
    t10 = event => {
      event.preventDefault();
      focusInput();
    };
    t11 = selected.map(product_2 => <Badge key={product_2.id} className="gap-1 pr-1.5" variant="outline" onMouseDown={event_0 => {
      event_0.preventDefault();
      focusInput();
    }}><span>{product_2.name}</span><Button variant="ghost" size="icon" className="h-5 w-5 rounded-full" onMouseDown={event_1 => {
        event_1.preventDefault();
        event_1.stopPropagation();
        focusInput();
      }} onClick={() => removeProduct(product_2)} aria-label={`Remove ${product_2.name}`}><X className="h-3 w-3" /></Button></Badge>);
    $[17] = className;
    $[18] = onChange;
    $[19] = selected;
    $[20] = addProduct;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
    $[24] = t13;
    $[25] = t9;
  } else {
    addProduct = $[20];
    t10 = $[21];
    t11 = $[22];
    t12 = $[23];
    t13 = $[24];
    t9 = $[25];
  }
  let t14;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = event_2 => setSearch(event_2.target.value);
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== addProduct || $[30] !== suggestions) {
    t15 = event_3 => {
      if (event_3.key === "Enter") {
        event_3.preventDefault();
        const firstMatch = suggestions[0];
        if (firstMatch) {
          addProduct(firstMatch);
        }
      }
    };
    $[29] = addProduct;
    $[30] = suggestions;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== placeholder || $[33] !== search || $[34] !== t15) {
    t16 = <Input ref={inputRef} value={search} placeholder={placeholder} onChange={t14} onKeyDown={t15} className="h-auto min-w-[120px] flex-1 border-0 px-0 pr-0 pl-1 text-base shadow-none focus-visible:ring-0 focus-visible:ring-offset-0 dark:bg-transparent" />;
    $[32] = placeholder;
    $[33] = search;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t10 || $[37] !== t11 || $[38] !== t16 || $[39] !== t9) {
    t17 = <div className={t9} onMouseDown={t10}>{t11}{t16}</div>;
    $[36] = t10;
    $[37] = t11;
    $[38] = t16;
    $[39] = t9;
    $[40] = t17;
  } else {
    t17 = $[40];
  }
  let t18;
  if ($[41] !== addProduct || $[42] !== isLoading || $[43] !== suggestions || $[44] !== trimmedSearch.length) {
    t18 = trimmedSearch.length > 0 && <div className="bg-card text-foreground border-input absolute top-full right-0 left-0 z-20 mt-1 max-h-72 overflow-y-auto rounded-md border shadow-sm">{isLoading && <div className="text-muted-foreground px-3 py-2 text-sm">Loading...</div>}{!isLoading && suggestions.length === 0 && <div className="text-muted-foreground px-3 py-2 text-sm">No matching products</div>}{!isLoading && suggestions.map(product_3 => <button key={product_3.id} type="button" onMouseDown={_temp2} onClick={() => addProduct(product_3)} className="hover:bg-accent flex w-full items-start px-3 py-2 text-left text-sm">{product_3.name}</button>)}</div>;
    $[41] = addProduct;
    $[42] = isLoading;
    $[43] = suggestions;
    $[44] = trimmedSearch.length;
    $[45] = t18;
  } else {
    t18 = $[45];
  }
  let t19;
  if ($[46] !== t12 || $[47] !== t17 || $[48] !== t18) {
    t19 = <div className={t12}>{t17}{t18}</div>;
    $[46] = t12;
    $[47] = t17;
    $[48] = t18;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== t13 || $[51] !== t19) {
    t20 = <div className={t13}>{t19}</div>;
    $[50] = t13;
    $[51] = t19;
    $[52] = t20;
  } else {
    t20 = $[52];
  }
  return t20;
}
function _temp2(event_4) {
  event_4.preventDefault();
}
function _temp(product) {
  return getId(product);
}